"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COUPONS_OFFERS_SECTION_DEFAULTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _ApplyCouponCard = _interopRequireDefault(require("../ApplyCouponCard/ApplyCouponCard"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["title", "titleColor", "onViewAll", "viewAllText", "viewAllColor", "coupons", "children", "background", "fontFamily", "paddingX", "paddingY", "headingGap", "cardGap", "sx"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const COUPONS_OFFERS_SECTION_DEFAULTS = exports.COUPONS_OFFERS_SECTION_DEFAULTS = {
  title: 'Coupons & Offers',
  titleColor: '#0f0b28',
  viewAllText: 'View All',
  viewAllColor: '#686670',
  background: '#ffffff',
  fontFamily: 'Inter, sans-serif',
  paddingX: 20,
  paddingY: 12,
  headingGap: 12,
  cardGap: 12
};
const CouponsOffersSection = _ref => {
  let _ref$title = _ref.title,
    title = _ref$title === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.title : _ref$title,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.titleColor : _ref$titleColor,
    onViewAll = _ref.onViewAll,
    _ref$viewAllText = _ref.viewAllText,
    viewAllText = _ref$viewAllText === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.viewAllText : _ref$viewAllText,
    _ref$viewAllColor = _ref.viewAllColor,
    viewAllColor = _ref$viewAllColor === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.viewAllColor : _ref$viewAllColor,
    _ref$coupons = _ref.coupons,
    coupons = _ref$coupons === void 0 ? [{}] : _ref$coupons,
    children = _ref.children,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.background : _ref$background,
    _ref$fontFamily = _ref.fontFamily,
    fontFamily = _ref$fontFamily === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.fontFamily : _ref$fontFamily,
    _ref$paddingX = _ref.paddingX,
    paddingX = _ref$paddingX === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.paddingX : _ref$paddingX,
    _ref$paddingY = _ref.paddingY,
    paddingY = _ref$paddingY === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.paddingY : _ref$paddingY,
    _ref$headingGap = _ref.headingGap,
    headingGap = _ref$headingGap === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.headingGap : _ref$headingGap,
    _ref$cardGap = _ref.cardGap,
    cardGap = _ref$cardGap === void 0 ? COUPONS_OFFERS_SECTION_DEFAULTS.cardGap : _ref$cardGap,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
    sx: {
      py: "".concat(paddingY, "px"),
      background: '#F2F2F3'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, _objectSpread(_objectSpread({
      sx: _objectSpread({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: "".concat(headingGap, "px"),
        px: "".concat(paddingX, "px"),
        py: "".concat(paddingY, "px"),
        background,
        width: '100%',
        boxSizing: 'border-box'
      }, sx)
    }, rest), {}, {
      children: [(title || onViewAll) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: '12px'
        },
        children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: 1.4,
            letterSpacing: '0.25px',
            color: titleColor,
            m: 0
          },
          children: title
        }), onViewAll && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
          disableRipple: true,
          onClick: onViewAll,
          sx: {
            flexShrink: 0
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              fontFamily,
              fontWeight: 500,
              fontSize: '11px',
              lineHeight: 1.6,
              color: viewAllColor,
              textDecoration: 'underline',
              whiteSpace: 'nowrap',
              m: 0
            },
            children: viewAllText
          })
        })]
      }), children || /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: "".concat(cardGap, "px")
        },
        children: coupons.map((couponProps, index) => {
          var _couponProps$key;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApplyCouponCard.default, _objectSpread({}, couponProps), (_couponProps$key = couponProps.key) !== null && _couponProps$key !== void 0 ? _couponProps$key : index);
        })
      })]
    }))
  });
};
var _default = exports.default = CouponsOffersSection;